export default __webpack_public_path__ + "static/wy-logo-4-bad729f208a6ed0a82ea9a54d0262ebc.png";